import React, { ReactNode } from 'react';
import { Box, Stack, Text, List, ListItem, TextLink, MarkdownLite } from '@origin-digital/ods-core';
import { StaticPerkAccordionType } from '../../typings';

const BatteryMaximiserPerkSummary: ReactNode = <Text weight="medium">Important info</Text>;

const BatteryMaximiserPerkBody: React.ReactNode = (
  <Stack space="medium">
    <Box>
      <List space="xxsmall">
        <ListItem>
          <Text>
            This is an electricity plan and you must be connected to our Loop VPP for smart
            automation to import and export energy.
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            You can earn feed-in tariffs when we discharge your battery during high-demand events or
            from excess solar. We’ll only charge your battery if its state of charge is low and an
            event is forecast.
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            <TextLink
              data-id="battery-Maximiser-terms-link"
              href="https://www.originenergy.com.au/solar/battery-plans/maximiser/" // TODO is this correct link ?
              target="_blank"
            >
              Learn more about how Battery Maximiser orchestrates your battery.
            </TextLink>
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            <MarkdownLite>
              Before signing up confirm your **eligibility**. See T&C’s below.
            </MarkdownLite>
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            If you do not meet the eligibility requirements during this Energy Plan then the Energy
            Plan will continue but you won’t receive the feed-in tariffs
          </Text>
        </ListItem>
      </List>
    </Box>
  </Stack>
);

export const BatteryMaximiserPerk: StaticPerkAccordionType = {
  accordionIcon:
    'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_battery_wall.svg',
  accordionSummary: BatteryMaximiserPerkSummary,
  accordionBody: BatteryMaximiserPerkBody,
  accordionDataId: 'battery-maximiser-perk',
  expanded: true,
  synced: true,
};
